// Account types shown on the signup form. Labels/structure are SUBJECT TO CHANGE — pricing and
// the actual entitlement limits are finalized in a later layer (this just drives the selector).
export const ACCOUNT_TYPES = [
  { value: 'demo',       label: 'Demo',       tagline: 'Guided tour on sample data — nothing real is sent.' },
  { value: 'basic',      label: 'Basic',      tagline: 'Solo operator. Connect your own MLS + DocuSign.' },
  { value: 'pro',        label: 'Pro',        tagline: 'Higher limits, voicemail, AI acquisition agent.' },
  { value: 'enterprise', label: 'Enterprise', tagline: 'Brokerage — multiple agents under one organization.' },
];

export const DEFAULT_ACCOUNT_TYPE = 'demo';
